export const getTourStepsForItem = (key, lobbyData, that) => {
    const tourStepsMap = {
        aiChatbot: [
            {
                target: ".story-add",
                title: that.$t("setupWizard.aiChatbot.steps.step1.title"),
                content: that.$t("setupWizard.aiChatbot.steps.step1.content"),
                arrowPosition: "left",
                gif: "/static/img/step/chatbot-step.gif",
                routerUrl: "/chatbot",
            },
            {
                target: ".template-list-item-inner-wrapper",
                title: that.$t("setupWizard.aiChatbot.steps.step2.title"),
                content: that.$t("setupWizard.aiChatbot.steps.step2.content"),
                arrowPosition: "left",
                gif: "/static/img/step/chatbot-step.gif",
                routerUrl: "/chatbot/templates",
            },
            {
                target: ".whatsapp",
                title: that.$t("setupWizard.aiChatbot.steps.step3.title"),
                content: that.$t("setupWizard.aiChatbot.steps.step3.content"),
                arrowPosition: "right",
                routerUrl: "/chatbot/integrations",
            },
            {
                target: ".archives-list-filters",
                title: that.$t("setupWizard.aiChatbot.steps.step4.title"),
                content: that.$t("setupWizard.aiChatbot.steps.step4.content"),
                arrowPosition: "top",
                routerUrl: "/chatbot/reports/overall?period=today&integration&storyId",
            },
        ],
        aiAssistant: [
            {
                target: ".channel-add",
                title: that.$t("setupWizard.aiAssistant.steps.step1.title"),
                content: that.$t("setupWizard.aiAssistant.steps.step1.content"),
                arrowPosition: "left",
                routerUrl: "/integrations/openai",
            },
        ],
        aiLiveSupport: [
            {
                target: ".filters-tabs",
                title: that.$t("setupWizard.aiLiveSupport.steps.step1.title"),
                content: that.$t("setupWizard.aiLiveSupport.steps.step1.content"),
                arrowPosition: "top",
                routerUrl: "/chat",
            },
            {
                target: ".add-button",
                title: that.$t("setupWizard.aiLiveSupport.steps.step2.title"),
                content: that.$t("setupWizard.aiLiveSupport.steps.step2.content"),
                arrowPosition: "top",
                routerUrl: "/chat",
            },
            {
                target: ".btn-contact-switch",
                title: that.$t("setupWizard.aiLiveSupport.steps.step3.title"),
                content: that.$t("setupWizard.aiLiveSupport.steps.step3.content"),
                arrowPosition: "top",
                routerUrl: "/chat",
            },
            {
                target: ".empty-conversations-content-action",
                title: that.$t("setupWizard.aiLiveSupport.steps.step4.title"),
                content: that.$t("setupWizard.aiLiveSupport.steps.step4.content"),
                arrowPosition: "bottom",
                routerUrl: "/chat",
                marginBottom: 90,
            },
        ],
        aiAutomation: [
            {
                target: ".ant-dropdown-trigger",
                title: that.$t("setupWizard.aiAutomation.steps.step1.title"),
                content: that.$t("setupWizard.aiAutomation.steps.step1.content"),
                arrowPosition: "right",
                routerUrl: "/automations",
            },
            {
                target: ".category-btn",
                title: that.$t("setupWizard.aiAutomation.steps.step2.title"),
                content: that.$t("setupWizard.aiAutomation.steps.step2.content"),
                arrowPosition: "right",
                routerUrl: "/automations",
            },
            {
                target: ".operated-task-count",
                title: that.$t("setupWizard.aiAutomation.steps.step3.title"),
                content: that.$t("setupWizard.aiAutomation.steps.step3.content"),
                arrowPosition: "top",
                routerUrl: "/automations",
            },
            {
                target: ".filter-container",
                title: that.$t("setupWizard.aiAutomation.steps.step4.title"),
                content: that.$t("setupWizard.aiAutomation.steps.step4.content"),
                arrowPosition: "top",
                routerUrl: "/automations/automation-insights",
            },
        ],
        aiDynamicCrm: [
            {
                target: ".filter-sidebar",
                title: that.$t("setupWizard.aiDynamicCrm.steps.step1.title"),
                content: that.$t("setupWizard.aiDynamicCrm.steps.step1.content"),
                arrowPosition: "left",
                routerUrl: "/visitors?page=1&perPage=10",
            },
            {
                target: ".supsis-table",
                title: that.$t("setupWizard.aiDynamicCrm.steps.step2.title"),
                content: that.$t("setupWizard.aiDynamicCrm.steps.step2.content"),
                arrowPosition: "right",
                routerUrl: "/visitors?page=1&perPage=10",
            },
            {
                target: ".block-manual-button",
                title: that.$t("setupWizard.aiDynamicCrm.steps.step3.title"),
                content: that.$t("setupWizard.aiDynamicCrm.steps.step3.content"),
                arrowPosition: "right",
                routerUrl: "/visitors?tab=banned-visitors",
            },
            {
                target: ".add-tag-button",
                title: that.$t("setupWizard.aiDynamicCrm.steps.step4.title"),
                content: that.$t("setupWizard.aiDynamicCrm.steps.step4.content"),
                arrowPosition: "right",
                routerUrl: "/visitors?tab=tags",
            },
            {
                target: ".add-profile-field-button",
                title: that.$t("setupWizard.aiDynamicCrm.steps.step5.title"),
                content: that.$t("setupWizard.aiDynamicCrm.steps.step5.content"),
                arrowPosition: "right",
                routerUrl: "/visitors?tab=profile-fields",
            },
        ],
        whatsappBusiness: [
            {
                target: ".channel-add",
                title: that.$t("setupWizard.whatsappBusiness.steps.step1.title"),
                content: that.$t("setupWizard.whatsappBusiness.steps.step1.content"),
                arrowPosition: "left",
                routerUrl: "/integrations/whatsapp-business-api",
            },
        ],
        whatsappWeb: [
            {
                target: ".channel-add",
                title: that.$t("setupWizard.whatsappWeb.steps.step1.title"),
                content: that.$t("setupWizard.whatsappWeb.steps.step1.content"),
                arrowPosition: "left",
                routerUrl: "/integrations/whatsapp-v2",
            },
        ],
        instagram: [
            {
                target: ".channel-add",
                title: that.$t("setupWizard.instagram.steps.step1.title"),
                content: that.$t("setupWizard.instagram.steps.step1.content"),
                arrowPosition: "left",
                routerUrl: "/integrations/instagram",
            },
        ],
        facebook: [
            {
                target: ".channel-add",
                title: that.$t("setupWizard.facebook.steps.step1.title"),
                content: that.$t("setupWizard.facebook.steps.step1.content"),
                arrowPosition: "left",
                routerUrl: "/integrations/messenger",
            },
        ],
        telegram: [
            {
                target: ".channel-add",
                title: that.$t("setupWizard.telegram.steps.step1.title"),
                content: that.$t("setupWizard.telegram.steps.step1.content"),
                arrowPosition: "left",
                routerUrl: "/integrations/telegram-qr",
            },
        ],
        mail: [
            {
                target: ".supsis-button",
                title: that.$t("setupWizard.mail.steps.step1.title"),
                content: that.$t("setupWizard.mail.steps.step1.content"),
                arrowPosition: "top",
                routerUrl: "/mails",
            },
            {
                target: ".right-section",
                title: that.$t("setupWizard.mail.steps.step2.title"),
                content: that.$t("setupWizard.mail.steps.step2.content"),
                arrowPosition: "right",
                routerUrl: "/mails/templates",
            },
            {
                target: ".broadcast-title",
                title: that.$t("setupWizard.mail.steps.step3.title"),
                content: that.$t("setupWizard.mail.steps.step3.content"),
                arrowPosition: "top",
                routerUrl: "/mails/broadcast",
            },
            {
                target: ".title-content",
                title: that.$t("setupWizard.mail.steps.step4.title"),
                content: that.$t("setupWizard.mail.steps.step4.content"),
                arrowPosition: "top",
                routerUrl: "/mails/customer-groups",
                slowMode: true,
            },
        ],
        metaLead: [
            {
                target: ".channel-add",
                title: that.$t("setupWizard.metaLead.steps.step1.title"),
                content: that.$t("setupWizard.metaLead.steps.step1.content"),
                arrowPosition: "left",
                routerUrl: "/integrations/meta-leads",
            },
        ],
        trendyol: [
            {
                target: ".channel-add",
                title: that.$t("setupWizard.trendyol.steps.step1.title"),
                content: that.$t("setupWizard.trendyol.steps.step1.content"),
                arrowPosition: "left",
                routerUrl: "/integrations/trendyol",
            },
        ],
        formSurvey: [
            {
                target: ".card-content",
                title: that.$t("setupWizard.formSurvey.steps.step1.title"),
                content: that.$t("setupWizard.formSurvey.steps.step1.content"),
                arrowPosition: "top",
                routerUrl: "/form?type=form",
            },
            {
                target: ".header",
                title: that.$t("setupWizard.formSurvey.steps.step2.title"),
                content: that.$t("setupWizard.formSurvey.steps.step2.content"),
                arrowPosition: "top",
                routerUrl: "/form?type=list",
            },
        ],

        processManagement: [
            {
                target: ".workflow-card",
                title: that.$t("setupWizard.processManagement.steps.step1.title"),
                content: that.$t("setupWizard.processManagement.steps.step1.content"),
                arrowPosition: "left",
                routerUrl: "/tasks?type=workflowList",
            },
            {
                target: ".ve-table-header-tr",
                title: that.$t("setupWizard.processManagement.steps.step2.title"),
                content: that.$t("setupWizard.processManagement.steps.step2.content"),
                arrowPosition: "top",
                routerUrl: "/tasks?type=list",
            },
            {
                target: ".add-tag-button",
                title: that.$t("setupWizard.processManagement.steps.step3.title"),
                content: that.$t("setupWizard.processManagement.steps.step3.content"),
                arrowPosition: "right",
                routerUrl: "/tasks?type=tags",
            },
            {
                target: ".ve-table-enable-cell-selection",
                title: that.$t("setupWizard.processManagement.steps.step4.title"),
                content: that.$t("setupWizard.processManagement.steps.step4.content"),
                arrowPosition: "top",
                routerUrl: "/tasks?type=archive",
            },
            {
                target: ".ve-table-enable-cell-selection",
                title: that.$t("setupWizard.processManagement.steps.step5.title"),
                content: that.$t("setupWizard.processManagement.steps.step5.content"),
                arrowPosition: "top",
                routerUrl: "/tasks?type=done",
            },
        ],

        calendar: [
            {
                target: ".vc-container",
                title: that.$t("setupWizard.calendar.steps.step1.title"),
                content: that.$t("setupWizard.calendar.steps.step1.content"),
                arrowPosition: "top",
                routerUrl: "/calendar",
            },
            {
                target: ".fc-landingPage-button",
                title: that.$t("setupWizard.calendar.steps.step2.title"),
                content: that.$t("setupWizard.calendar.steps.step2.content"),
                arrowPosition: "top",
                routerUrl: "/calendar",
            },
            {
                target: ".preview-button",
                title: that.$t("setupWizard.calendar.steps.step3.title"),
                content: that.$t("setupWizard.calendar.steps.step3.content"),
                arrowPosition: "right",
                routerUrl: "/reservation/landing-page",
            },
            {
                target: ".new-reservation-button",
                title: that.$t("setupWizard.calendar.steps.step4.title"),
                content: that.$t("setupWizard.calendar.steps.step4.content"),
                arrowPosition: "right",
                routerUrl: "/calendar/reservations",
            },
        ],
        websiteAnalysis: [
            {
                target: ".total-visitor-count",
                title: that.$t("setupWizard.websiteAnalysis.steps.step1.title"),
                content: that.$t("setupWizard.websiteAnalysis.steps.step1.content"),
                arrowPosition: "bottom",
                routerUrl: "/report-new?report=website-analysis",
            },
            {
                target: ".average-visitor-count",
                title: that.$t("setupWizard.websiteAnalysis.steps.step2.title"),
                content: that.$t("setupWizard.websiteAnalysis.steps.step2.content"),
                arrowPosition: "bottom",
                routerUrl: "/report-new?report=website-analysis",
            },
            {
                target: ".max-visitor-count",
                title: that.$t("setupWizard.websiteAnalysis.steps.step3.title"),
                content: that.$t("setupWizard.websiteAnalysis.steps.step3.content"),
                arrowPosition: "bottom",
                routerUrl: "/report-new?report=website-analysis",
            },
            {
                target: ".min-visitor-count",
                title: that.$t("setupWizard.websiteAnalysis.steps.step4.title"),
                content: that.$t("setupWizard.websiteAnalysis.steps.step4.content"),
                arrowPosition: "bottom",
                routerUrl: "/report-new?report=website-analysis",
            },
        ],

        ticketSystem: [
            {
                target: ".new-status-button",
                title: that.$t("setupWizard.ticketSystem.steps.step1.title"),
                content: that.$t("setupWizard.ticketSystem.steps.step1.content"),
                arrowPosition: "top",
                routerUrl: "/ticket",
            },
            {
                target: ".list-status-button",
                title: that.$t("setupWizard.ticketSystem.steps.step2.title"),
                content: that.$t("setupWizard.ticketSystem.steps.step2.content"),
                arrowPosition: "top",
                routerUrl: "/ticket",
            },
            {
                target: ".view-switcher",
                title: that.$t("setupWizard.ticketSystem.steps.step3.title"),
                content: that.$t("setupWizard.ticketSystem.steps.step3.content"),
                arrowPosition: "right",
                routerUrl: "/ticket",
            },
        ],
        dynamicTables: [
            {
                target: ".category-btn",
                title: that.$t("setupWizard.dynamicTables.steps.step1.title"),
                content: that.$t("setupWizard.dynamicTables.steps.step1.content"),
                arrowPosition: "top",
                routerUrl: "/tables",
            },
            {
                target: ".new-table-button",
                title: that.$t("setupWizard.dynamicTables.steps.step2.title"),
                content: that.$t("setupWizard.dynamicTables.steps.step2.content"),
                arrowPosition: "top",
                routerUrl: "/tables",
            },
            {
                target: ".ai-suggest-button",
                title: that.$t("setupWizard.dynamicTables.steps.step3.title"),
                content: that.$t("setupWizard.dynamicTables.steps.step3.content"),
                arrowPosition: "top",
                routerUrl: "/tables",
            },
        ],
        aiVoice: [
            {
                target: ".channel-add",
                title: that.$t("setupWizard.aiVoice.steps.step1.title"),
                content: that.$t("setupWizard.aiVoice.steps.step1.content"),
                arrowPosition: "left",
                routerUrl: "/integrations/voice-agent",
            },
        ],
    };

    return tourStepsMap[key] || [];
};
